import React, { useEffect, useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import reactStringReplace from 'react-string-replace'
import * as Icons from 'react-feather'
import AddFinanceRegister from './AddFinanceRegister'
import DeleteFinanceRegister from './DeleteFinanceRegister'
import ViewFinanceRegister from './ViewFinanceRegister'
import EditFinanceRegister from './EditFinanceRegister'
import FinanceRegisterModel from './models/FinanceRegisterModel'
import { logAuditEvent } from '../../utils/auditLogger'
import { useCallback } from 'react'
import LoanSummaryModal from '../../shared/finance/LoanSummaryModal'
import EmailMessage from '../../shared/email-message/EmailMessage'

function FinanceRegisterModal({ onClose, onSubmit, UserAction, show, selectedRow, moduleName = 'Finance Register' }) {
    const [childData, setChildData] = useState(new FinanceRegisterModel() || [])
    const childDataRef = useRef(new FinanceRegisterModel())
    const [loanSummary, setLoanSummary] = useState(null);
    const [showLoanSummary, setShowLoanSummary] = useState(false);
    const loanSummaryApplyRef = useRef(null);
    const emailRef = useRef(null);
    let modalAction
    let showButtons
    let userAction = reactStringReplace(UserAction, 'User', () => '')

    useEffect(() => {
        if (show) {
            if (selectedRow) {
                const next = { ...selectedRow }
                childDataRef.current = next
                setChildData(next)
            } else {
                const next = new FinanceRegisterModel()
                childDataRef.current = next
                setChildData(next)
            }
            return
        }
        const reset = new FinanceRegisterModel()
        childDataRef.current = reset
        setChildData(reset)
    }, [selectedRow, show])

    const handleDataFromChild = (data) => {
        if (typeof data === 'function') {
            setChildData((prev) => {
                const next = data(prev ?? new FinanceRegisterModel())
                childDataRef.current = next
                return next
            })
            return
        }
        const next = data ?? new FinanceRegisterModel()
        childDataRef.current = next
        setChildData(next)
    }
    const handleLoanSummaryRequest = useCallback((summary) => {
        setLoanSummary(summary);
        setShowLoanSummary(true);
    }, []);

    const closeLoanSummaryModal = useCallback((selectedSummary) => {
        setShowLoanSummary(false);
        if (selectedSummary && typeof loanSummaryApplyRef.current === 'function') {
            loanSummaryApplyRef.current(selectedSummary);
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault()
        const actionDescriptor = UserAction === 'Delete' ? 'Delete Confirm' : 'Save'
        logAuditEvent(moduleName, `${UserAction || 'Action'} ${actionDescriptor}`, `${actionDescriptor} clicked`)
        onSubmit(e, childDataRef.current)
    }

    const handleCancel = (label) => {
        logAuditEvent(moduleName, `${UserAction || 'Action'} ${label}`, `${label} clicked`)
        onClose()
    }

    const handleLoad = (data) => {
        const next = data ?? new FinanceRegisterModel()
        childDataRef.current = next
        setChildData(next)
    }

    if (UserAction === 'Add') {
    modalAction = <AddFinanceRegister onLoad={handleLoad} sendDataToParent={handleDataFromChild} onLoanSummary={handleLoanSummaryRequest} onLoanSummaryApply={(applyFn) => { loanSummaryApplyRef.current = applyFn }} />
        showButtons = (
            <div>
                <button className="btn btn-cancel me-2" name="Add" onClick={() => handleCancel('Cancel')}>Cancel</button>
                <button className="btn btn-submit" name="Add" onClick={handleSubmit}> Submit </button>
            </div>
        )
    } else if (UserAction === 'Edit') {
    modalAction = <EditFinanceRegister FinanceRegisterData={childData} onSubmit={onSubmit} sendDataToParent={handleDataFromChild} onLoanSummary={handleLoanSummaryRequest} onLoanSummaryApply={(applyFn) => { loanSummaryApplyRef.current = applyFn }} />
        showButtons = (
            <div>
                <button className="btn btn-cancel me-2" name="Edit" onClick={() => handleCancel('Cancel')}>Cancel</button>
                <button className="btn btn-submit" name="Edit" onClick={handleSubmit}> Submit </button>
            </div>
        )
    } else if (UserAction === 'View') {
            modalAction = <ViewFinanceRegister FinanceRegisterData={selectedRow} onCancel={() => handleCancel('Close')} />
            showButtons = null
    } else if (UserAction === 'Email') {
        modalAction = (
            <EmailMessage
                ref={emailRef}
                FinanceRegisterData={childData}
                onCancel={() => handleCancel('Cancel')}
                onSent={() => handleCancel('Close')}
                moduleName={moduleName}
            />
        )
        showButtons = null
    } else if (UserAction === 'Delete') {
        modalAction = <DeleteFinanceRegister FinanceRegisterData={selectedRow} />
        showButtons = (
            <div>
                <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={() => handleCancel('Delete Cancel')}>Cancel</button>
                <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit}>Delete</button>
            </div>
        )
    }

    return (
        <>
            {UserAction !== 'Delete'
                ? (
                    <Modal show={show} 
                        onHide={() => handleCancel('Close')} 
                        backdrop="static"
                        dialogClassName="add-centered-sales-modal" 
                    >
                        <ModalHeader className="modal-header border-0 custom-modal-header">
                            <ModalTitle>{userAction} {moduleName}</ModalTitle>
                            <button type="button" className="close" aria-label="Close" onClick={() => handleCancel('Close')}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </ModalHeader>
                        <ModalBody>{modalAction}</ModalBody>
                        <ModalFooter>{showButtons}</ModalFooter>
                    </Modal>
                )
                : (
                    <Modal show={show} onHide={() => handleCancel('Close')} backdrop="static">
                        <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
                            <ModalTitle>
                                <div className="custom-alert-icon">
                                    <Icons.AlertOctagon className="flex-shrink-0" />
                                </div>
                                <div>{userAction} {moduleName}</div>
                            </ModalTitle>
                            <button type="button" className="close" aria-label="Close" onClick={() => handleCancel('Close')}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </ModalHeader>
                        <ModalBody>{modalAction}</ModalBody>
                        <ModalFooter className="modalfooter-width">{showButtons}</ModalFooter>
                    </Modal>
                )}

            <LoanSummaryModal show={showLoanSummary} onClose={closeLoanSummaryModal} summary={loanSummary} />
        </>
    )
}

export default FinanceRegisterModal
